import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import classes from './buyOptionsContent.module.css';
import BuyLocalContent from '../buyLocalContent';
import BuyOnlineContent from '../buyOnlineContent';

function BuyOptionsContent(_ref) {
  var customAttributes = _ref.customAttributes;
  var tabs = [{
    id: 1,
    title: 'Buy Local'
  }, {
    id: 2,
    title: 'Buy Online'
  }];

  var _useState = useState(tabs[0].id),
      _useState2 = _slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setactiveTab = _useState2[1];

  return React.createElement("div", {
    className: classes.root
  }, React.createElement("div", {
    className: classes.tabs
  }, tabs.map(function (tab) {
    return React.createElement("h5", {
      className: tab.id === activeTab && classes.active,
      key: tab.id,
      onClick: function onClick() {
        return setactiveTab(tab.id);
      }
    }, tab.title);
  })), React.createElement("div", {
    className: classes.content
  }, activeTab === 1 ? React.createElement(BuyLocalContent, null) : React.createElement(BuyOnlineContent, {
    customAttributes: customAttributes
  })));
}

export default BuyOptionsContent;